import React from 'react';
import IFlightRangeData from '../../types/FlightRanges';
import FlightRangeModifyTable from '../FlightRange/FlightRangeModifyTable';
import './ConfirmationModal.scss';

interface ReplacementRange {
  id: string;
  marketingCarrier: string;
  start: number;
  end: number;
  flightType: string;
  flightTypeDescription: string;
  effectiveDate: string;
  operatingCarrier: string;
  discontinueDate?: string;
}

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedRanges: IFlightRangeData[];
  replacementRanges: ReplacementRange[];
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  selectedRanges,
  replacementRanges
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirmation-modal-overlay" role="presentation">
      <div
        className="confirmation-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirmation-modal-title"
      >
        <div className="confirmation-modal__header">
          <h2 id="confirmation-modal-title" className="confirmation-modal__title">
            Confirm Changes
          </h2>
          <button
            className="confirmation-modal__close-button"
            onClick={onClose}
            aria-label="Close confirmation modal"
          >
            ×
          </button>
        </div>
        
        <div className="confirmation-modal__content">
          <p>Please review the changes below before proceeding:</p>
          
          <div className="confirmation-modal__tables">
            <div className="confirmation-modal__table-section">
              <FlightRangeModifyTable
                title="Discontinued Flight(s)"
                ranges={selectedRanges}
                showRemoveButton={false}
              />
            </div>
            
            <div className="confirmation-modal__table-section">
              <FlightRangeModifyTable
                title="Replacement Flight(s)"
                ranges={replacementRanges}
                showRemoveButton={false}
              />
            </div>
          </div>
          
          <div className="confirmation-modal__message">
            <p>Are you sure you want to proceed with these modifications?</p>
          </div>
        </div>
        
        <div className="confirmation-modal__footer">
          <div className="confirmation-modal__footer-container">
            <div className="confirmation-modal__footer-left">
              <auro-button
                className="confirmation-modal__go-back-button"
                onClick={onClose}
                aria-label="Go back to flight ranges modification"
                variant='secondary'
                size='md'
              >
                Go back
              </auro-button>
              <auro-button
                className="confirmation-modal__save-draft-button"
                onClick={onClose}
                aria-label="Save changes as draft"
                variant='tertiary'
                size='md'
              >
                Save as draft
              </auro-button>
            </div>
            <div className="confirmation-modal__footer-right">
              <auro-button
                className="confirmation-modal__confirm-button"
                onClick={onConfirm}
                aria-label="Confirm changes and notify"
                variant="primary"
                size="md"
                responsive
                fluid
                style={
                    {
                    '--ds-auro-button-container-image': 'var(--color-primary, #0074ca)',
                    minWidth: '212px',
                    height: '50px'
                    } as React.CSSProperties
                }
              >
                Confirm and notify
              </auro-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
